import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { userActions } from '@app/store/user/actions/user.actions';
import { usersActions } from '../actions/users.actions';
import { selectQuery } from '../selectors/users.selector';

/** Deletes go through the `user` store; the list replays its last request once one succeeds. */
@Injectable()
export class UsersUserBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(userActions.deleteUserSuccess),
            concatLatestFrom(() => this.store.select(selectQuery)),
            map(([, value]) => usersActions.getUsers({ value })),
        );
    });
}
